<template>
  <div>
    <Loader v-if="isLoading" />
    <router-view />
  </div>
</template>

<script lang="ts">
import Loader from '@/components/legacy/Loader.vue';
import { Component, Vue } from 'vue-property-decorator';
@Component({
  name: 'basic-rating-layout',
  components: {
    Loader,
  },
})
export default class BasicRatingLayout extends Vue {
  private get isLoading() {
    return this.$store.state.isLoading;
  }
  private created() {
    if (!this.$store.state.config && this.$route.name !== 'rating') {
      if (this.$route.params.slug) {
        this.$router.push({
          name: 'rating',
          params: { slug: this.$route.params.slug },
        });
      } else if (this.$route.name !== 'error') {
        this.$router.push({ name: 'error' });
      }
    }
  }
}
</script>
